import _ from "lodash";
import constants from "../helpers/constants";
import dateHelper from "../helpers/dateHelper";

interface SiteHours {
  siteId: number;
  dayOfWeek: number;
  openingTime: string;
  closingTime: string;
}

interface ScheduleSite {
  siteId: number;
  openingTime: string;
  closingTime: string;
}

interface SelectedSite {
  siteId: number;
  state: string;
  timeZoneName?: string;
  openingTime?: string;
  closingTime?: string;
  isSiteOpen?: boolean;
  isAddressSelected?: boolean;
}

interface Data {
  sites: SelectedSite[];
  scheduleSites?: ScheduleSite[];
  siteHours: SiteHours[];
}

function setSitesUtil(data: Data, selectedSiteId?: number): SelectedSite[] {
  const sites = _.map(data.sites, (selectedSite: SelectedSite) => {
    selectedSite.timeZoneName = constants.refTimezones[selectedSite.state as keyof typeof constants.refTimezones];
    const scheduleSite = data.scheduleSites?.find((hs) => hs.siteId === selectedSite.siteId);

    if (scheduleSite) {
      selectedSite.openingTime = dateHelper.convertTimeZone(scheduleSite.openingTime, selectedSite.timeZoneName);
      selectedSite.closingTime = dateHelper.convertTimeZone(scheduleSite.closingTime, selectedSite.timeZoneName);
      selectedSite.isSiteOpen = dateHelper.isSiteOpen(null, selectedSite as Required<SelectedSite>);
    } else {
      const matchedSite = data.siteHours.find((i) => i.siteId === selectedSite.siteId && i.dayOfWeek === dateHelper.getWeekday());
      if (matchedSite) {
        selectedSite.openingTime = dateHelper.convertTimeZone(matchedSite.openingTime, selectedSite.timeZoneName);
        selectedSite.closingTime = dateHelper.convertTimeZone(matchedSite.closingTime, selectedSite.timeZoneName);
        selectedSite.isSiteOpen = dateHelper.isSiteOpen(null, selectedSite as Required<SelectedSite>);

        if (selectedSite.isSiteOpen === false && dateHelper.getCurrentHour(selectedSite.timeZoneName) <= 5) {
          const previousDaySite = data.siteHours.find((i) =>
            i.siteId === selectedSite.siteId &&
            i.dayOfWeek === dateHelper.getWeekday() - 1
          );
          if (previousDaySite) {
            selectedSite.openingTime = dateHelper.convertTimeZone(previousDaySite.openingTime, selectedSite.timeZoneName);
            selectedSite.closingTime = dateHelper.convertTimeZone(previousDaySite.closingTime, selectedSite.timeZoneName);
            selectedSite.isSiteOpen = dateHelper.isSiteOpen(null, selectedSite as Required<SelectedSite>);
          }
        }
      }
    }
    selectedSite.isAddressSelected = selectedSiteId
      ? selectedSite.siteId === selectedSiteId
      : false;
    return selectedSite;
  });

  return sites;
}

export default setSitesUtil;
